import React from 'react';
import {scroller} from 'react-scroll';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});

const Scroll = props => {
  const { classes } = props;

  const scrollToElement = (element) => {
    scroller.scrollTo(element,{
       duration: 1000,
       delay:100,
       smooth: true
    });
  };

  return (
    <div>
        <Button onClick={()=> scrollToElement('highlights')} variant="outlined" color="secondary" className={classes.button}>
          Highlight
        </Button>
    </div>
  );
};




export default withStyles(styles)(Scroll);